import { render, staticRenderFns } from "./SeeDoctorRecords.vue?vue&type=template&id=534f131c&scoped=true&"
import script from "./SeeDoctorRecords.vue?vue&type=script&lang=js&"
export * from "./SeeDoctorRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534f131c",
  null
  
)

export default component.exports